import React, {Component} from "react";
import axios from "axios";
import {Pie, Doughnut} from 'react-chartjs-2';
import {Chart, ArcElement, Tooltip, Legend} from 'chart.js'
import StudentList from "./students/StudentList";
import StudentBar from "./students/StudentBar";
import StudentLine from "./students/StudentLine";
import FeatherIcon from 'feather-icons-react';
import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import ReactToPrint from "react-to-print";
import Headerpdf from "../users/Headerpdf";
import UserIdentity from "../users/UserIdentity";
import { clearAppStoragePreservingTheme, getThemeColor } from "../../theme/branding";
import { isAuthenticationRejection } from "../../offline/sessionPolicy";
Chart.register(ArcElement, Tooltip, Legend);

class Dashboard extends Component{
    
    state = {
      sections : [],
      years : [],
      establishments : [],
      yearId : null,
      pie : { labels : [], datasets : [] },
      parentfamilies : 0,
      suppliers : 0,
      staffs : 0
    }

      componentDidMount(){
        this.refreshToken();
        this.getYears()
        this.getEstablishments()
        this.getsections()
        this.getStaffs()
        this.getSuppliers()
        this.getParentfamilies()
      }

      async refreshToken () {
        try{
          var token = await axios.get('token');
          if(token.status === 200)
          {
              var user = (token.data.data);
              localStorage.setItem("user", JSON.stringify(user));
              localStorage.setItem("yearId", token.data.data?.scolary_year)
              // localStorage.setItem("REACT_APP_EVIVESOMA_RH", token.data.ipAddress ? "http://" +token.data.ipAddress + ":8080/csedafstat" : "Wi-Fi not connect")
          }
        }catch(error) {
          if (!isAuthenticationRejection(error)) {
            console.info("Session conservée : validation du token indisponible hors connexion.");
            return;
          }

            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            clearAppStoragePreservingTheme();
            window.location.replace(process.env.REACT_APP_EVIVESOMA_RH + `/login`)
        }
    }
    
    async getsections(){
        var sections = await axios.get('sections');
        if(sections.status === 200)
        {
            this.setState({sections : sections.data}) 
        }
    }

    async getYears(){
        var years = await axios.get('years_');
        if(years.status === 200)
        {
            this.setState({years : years.data}) 
        }
    }

    async getEstablishments(){
        var establishments = await axios.get('establishments');
        if(establishments.status === 200)
        {
            this.setState({establishments : establishments.data}) 
        }
    }

      async getStaffs(){
        var staffs = await axios.get('staffs');
        if(staffs.status === 200)
        {
            this.setState({staffs : staffs.data.length}) 
        }
    }

    async getParentfamilies(){
        var parentfamilies = await axios.get('parentfamilies');
        if(parentfamilies.status === 200)
        {
            this.setState({parentfamilies : parentfamilies.data.length}) 
        }
    }

    async getSuppliers(){
      var suppliers = await axios.get('suppliers');
      if(suppliers.status === 200)
      {
          this.setState({suppliers : suppliers.data.length}) 
      }
    }

    async handle_ (e){
      let request = await axios.get("year/" + e.target.value)
      if(request.status === 200){
        axios.post('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
        clearAppStoragePreservingTheme();
        window.location.replace(process.env.REACT_APP_EVIVESOMA_RH)
      }
    }

    async handl (e){
      if(e.target.value === "") return;
      let request = await axios.put("staffsestablishment/", {establishmentId : e.target.value})
      if(request.status === 200){
        axios.post('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
        clearAppStoragePreservingTheme();
        window.location.replace(process.env.REACT_APP_EVIVESOMA_RH)
      }
    }

    handleCheck = (permission) => {
      const permissions = localStorage.getItem("permissions")
          ? JSON.parse(localStorage.getItem("permissions"))
          : [];
      return permissions.some(item => permission === item.permission);
    }

    render(){
      const dashboardAccent = getThemeColor();
      const chartTones = ['FF', 'E6', 'CC', 'B3', '99', '80', 'F2', 'D9', 'BF', 'A6', '8C', '73'].map(alpha => `${dashboardAccent}${alpha}`);
      const chartHoverTones = ['FF', 'F2', 'E6', 'D9', 'CC', 'BF', 'FF', 'F2', 'E6', 'D9', 'CC', 'BF'].map(alpha => `${dashboardAccent}${alpha}`);
      
      var sections = "", students = 0, student = 0, studentTotal = 0, classes = 0, labels = [], data = [], labelBar = [], dataBar = [] ;
      
      sections = 
      this.state.sections.map((section) => {
        students = 0
        section.sectionclasses.sort((a, b) => a.class.short_entitled_class > b.class.short_entitled_class ? 1 : -1).forEach((sectionclasse) => {
            student = parseInt(sectionclasse.students.length)
            students = parseInt(students) + student
            labels.push(sectionclasse.class.short_entitled_class + "  " + sectionclasse.title + " " + section.short_entitled_section)
            data.push(student)
            
        })
        studentTotal = parseInt(studentTotal) + parseInt(students)
        classes = parseInt(classes) + parseInt(section.sectionclasses.length)
        labelBar.push(section.short_entitled_section)
        dataBar.push(students)

        // pie sections
        // labels.push(section.entitled_section)
        
        return(
          <div className="col-lg-4 col-sm-6" key={section.id}>
            <article className="people-section-card">
              <div className="people-section-card__top">
                <span className="people-section-card__icon"><FeatherIcon icon="layers" /></span>
                <span className="people-section-card__code">{section.short_entitled_section || 'Section'}</span>
              </div>
              <h3>{section.entitled_section}</h3>
              <div className="people-section-card__stats">
                <span><strong>{students}</strong><small>élèves</small></span>
                <span><strong>{section.sectionclasses.length}</strong><small>classes</small></span>
              </div>
              <div className="people-section-card__actions">
                <Link to="/students">Voir les élèves <FeatherIcon icon="arrow-right" /></Link>
                <Link to="/classes" aria-label={`Voir les classes de ${section.entitled_section}`}><FeatherIcon icon="grid" /></Link>
              </div>
            </article>
          </div>
        )
        })

      var dataPie = { 
        labels : labelBar,
        datasets : [
          {
            label: 'Statistique',
            backgroundColor: chartTones,
            hoverBackgroundColor: chartHoverTones,
            data: dataBar
          }
        ]
      };

      var state = {
        labels: ['Eleves', 'Personnel', 'Parent', 'Fournisseur'],
        datasets: [
          {
            label: 'Statistique',
            backgroundColor: chartTones.slice(0, 4),
            hoverBackgroundColor: chartHoverTones.slice(0, 4),
            data: [studentTotal, this.state.staffs, this.state.parentfamilies, this.state.suppliers]
          }
        ]
      }

        return(
            <div className="ev-dashboard ev-dashboard--people">
                <Helmet>
                    <title>{ process.env.REACT_APP_NAME } | dashboard</title>
                </Helmet>


                {/* <div className="d-flex justify-content-between"><span></span><a href={  ipAddress } className="text-small small font-11"><i>{ ipAddress }</i></a></div> */}
                <div className="people-hero">
                    <div className="ev-dashboard__heading">
                        <span className="ev-dashboard__eyebrow">Tableau de bord RH & scolaire</span>
                        <h1 className="ev-dashboard__title">Toute la communauté, <em>en un regard</em></h1>
                        <p className="ev-dashboard__subtitle">Suivez les effectifs, l'organisation des classes et les derniers mouvements de l'établissement.</p>
                    </div>
                    <div className="people-hero__tools">
                      <div className="people-hero__total"><FeatherIcon icon="users" size="20" /><strong>{studentTotal}</strong><span>élèves inscrits</span></div>
                      <div className="ev-dashboard__actions">
                        {
                          this.handleCheck("Afficher etablissement") && (
                             <label className="people-year"><span>Niveau Scolaire</span>
                            
                              <select aria-label="Niveau Scolaire" value={ localStorage.getItem("establishmentId")} onChange={this.handl}>
                                <option>----</option>
                                  {
                                    this.state.establishments?.map((val) =>(
                                      <option value={val.id} key={val.id}>{ val.countryCode }</option>
                                    ))
                                  }
                              </select>
                            </label>
                          )
                        }

                        <label className="people-year"><span>Année scolaire</span>
                          <select aria-label="Année scolaire" value={ localStorage.getItem("yearId")} onChange={this.handle_}>
                              {
                                this.state.years?.map((val) =>(
                                  <option value={val.id} key={val.id}>{ val.year }</option>
                                ))
                              }
                          </select>
                        </label>

                        <ReactToPrint
                            trigger={() => <button className="ev-button ev-button--secondary ev-button--small people-print" type="button"><FeatherIcon icon={"printer"} size="18"></FeatherIcon> <span>Imprimer</span></button>}
                            content={() =>  this.componentRef}
                        />
                      </div>
                    </div>
                </div>

                <div className="people-kpis">
                  <Link to="/students"><i><FeatherIcon icon="users" /></i><span>Élèves</span><strong>{studentTotal}</strong><small>inscrits cette année</small><FeatherIcon className="people-kpis__arrow" icon="arrow-up-right" /></Link>
                  <Link to="/staffs"><i><FeatherIcon icon="briefcase" /></i><span>Personnel</span><strong>{this.state.staffs}</strong><small>membres de l'équipe</small><FeatherIcon className="people-kpis__arrow" icon="arrow-up-right" /></Link>
                  <Link to="/parentfamilies"><i><FeatherIcon icon="heart" /></i><span>Familles</span><strong>{this.state.parentfamilies}</strong><small>rattachées à l'école</small><FeatherIcon className="people-kpis__arrow" icon="arrow-up-right" /></Link>
                  <Link to="/classes"><i><FeatherIcon icon="grid" /></i><span>Classes</span><strong>{classes}</strong><small>dans {this.state.sections.length} sections</small><FeatherIcon className="people-kpis__arrow" icon="arrow-up-right" /></Link>
                </div>

                <div className="people-section-heading">
                  <div><span className="ev-dashboard__eyebrow">Analyse des effectifs</span><h2>Comprendre la répartition</h2></div>
                  <p>Des repères synthétiques pour visualiser l'équilibre entre sections et populations.</p>
                </div>
                <div className="people-overview" ref={el => (this.componentRef = el)}>
                  <Headerpdf />
                  <UserIdentity title={"Statistique"} /> 
                      
                  <div className="row people-overview__grid">
                    <div className="col-lg-5">
                      <div className="row print">
                      
                        <div className="col-md-6">
                          <Link to="/students" className="people-overview-card">
                            <span className="people-overview-card__icon"><FeatherIcon icon="users" /></span>
                            <span className="people-overview-card__content"><small>Population scolaire</small><strong>{studentTotal}</strong><em>élèves inscrits</em></span>
                            <FeatherIcon className="people-overview-card__arrow" icon="arrow-up-right" />
                          </Link>
                        </div>

                        <div className="col-md-6">
                          <Link to="/parentfamilies" className="people-overview-card">
                            <span className="people-overview-card__icon"><FeatherIcon icon="heart" /></span>
                            <span className="people-overview-card__content"><small>Communauté</small><strong>{this.state.parentfamilies}</strong><em>familles rattachées</em></span>
                            <FeatherIcon className="people-overview-card__arrow" icon="arrow-up-right" />
                          </Link>
                        </div>

                        <div className="col-md-6">
                          <Link to="/suppliers" className="people-overview-card">
                            <span className="people-overview-card__icon"><FeatherIcon icon="truck" /></span>
                            <span className="people-overview-card__content"><small>Partenaires</small><strong>{this.state.suppliers}</strong><em>fournisseurs actifs</em></span>
                            <FeatherIcon className="people-overview-card__arrow" icon="arrow-up-right" />
                          </Link>
                        </div>

                        <div className="col-md-6">
                          <Link to="/staffs" className="people-overview-card">
                            <span className="people-overview-card__icon"><FeatherIcon icon="briefcase" /></span>
                            <span className="people-overview-card__content"><small>Ressources humaines</small><strong>{this.state.staffs}</strong><em>membres du personnel</em></span>
                            <FeatherIcon className="people-overview-card__arrow" icon="arrow-up-right" />
                          </Link>
                        </div>

                        <div className="col-md-6">
                          <Link to="/sections" className="people-overview-card">
                            <span className="people-overview-card__icon"><FeatherIcon icon="layers" /></span>
                            <span className="people-overview-card__content"><small>Organisation</small><strong>{this.state.sections.length}</strong><em>sections scolaires</em></span>
                            <FeatherIcon className="people-overview-card__arrow" icon="arrow-up-right" />
                          </Link>
                        </div>

                        <div className="col-md-6">
                          <Link to="/classes" className="people-overview-card">
                            <span className="people-overview-card__icon"><FeatherIcon icon="grid" /></span>
                            <span className="people-overview-card__content"><small>Structure</small><strong>{classes}</strong><em>classes ouvertes</em></span>
                            <FeatherIcon className="people-overview-card__arrow" icon="arrow-up-right" />
                          </Link>
                        </div>

                      </div>
                    </div>
                    {/* {charts} */}
                    <div className="col-lg-7 people-overview__charts">
                      <div className="row">
                        <div className="col-6">
                          {
                            dataPie.labels.length > 0 && (
                                <Pie
                                    data={ dataPie }
                                    options={{
                                        title:{
                                        display:true,
                                        text:'Eleve par classe',
                                        fontSize:20
                                        },
                                        legend:{
                                        display:true,
                                        position:'right'
                                        }
                                    }}
                                />
                              )
                            }
                        </div>
                        <div className="col-6">
                            <Doughnut
                                data={state}
                                options={{
                                    title:{
                                    display:true,
                                    text:'eleve par section',
                                    fontSize:20
                                    },
                                    legend:{
                                    display:true,
                                    position:'right'
                                    }
                                }}
                            />
                        </div>
                      </div>
                    </div>
                    {/* end charts */}
                  </div>
                    {/* {end row} */}
                  <div className="people-sections__heading">
                    <div><span className="ev-dashboard__eyebrow">Organisation scolaire</span><h2>Sections de l'établissement</h2></div>
                    <Link to="/sections">Gérer les sections <FeatherIcon icon="arrow-up-right" /></Link>
                  </div>
                  <div className="row print people-sections">
                    {/* establishment section */}
                    {
                      sections
                    }
                  </div>
                </div>
                
                {/* start store and update */}

                <div className="people-section-heading people-section-heading--activity">
                  <div><span className="ev-dashboard__eyebrow">Activité récente</span><h2>Les derniers mouvements</h2></div>
                  <p>Suivez les ajouts, modifications et changements apportés aux dossiers des élèves.</p>
                </div>
                <div className="row people-activity">

                  <div className="col-md-6">
                    <StudentList orderBy={"Ajouter"} title="Élèves récemment enregistrés" />
                  </div>

                  <div className="col-md-6">
                    <StudentList orderBy={"Editer"}  title="Dossiers récemment modifiés"/>
                  </div>

                  <div className="col-md-12">
                      <div className="card shadow overflow-hidden mb-4">
                          <div className="card-body">
                          <div className="h6 border-bottom pb-2 font-monospace">Elèves par classe</div>
                          {
                             labels.length > 0 && ( <StudentLine labels={labels} data={data} title={"Elèves par classe"} />)
                          }
                          </div>
                      </div>
                  </div>
                
                  <div className="col-md-6">
                    <StudentList orderBy={"Archiver"} title="Derniers élèves archivés"/>
                  </div>

                  <div className="col-md-6">
                    <StudentList orderBy={"Supprimer"} title="Derniers élèves supprimés"/>
                  </div>

                </div>

                <div className="row">

                  <div className="col-md-12">
                      <div className="card shadow overflow-hidden mb-4">
                        <div className="card-body">
                          <div className="h6 border-bottom pb-2 font-monospace">Elèves par section</div>
                          {
                             labelBar.length > 0 && (
                                <StudentBar labels={labelBar} data={dataBar} title={"Elèves par section"}  />
                             )
                          }
                          </div>
                      </div>
                  </div> 
                </div>

            </div>
        )
    }
}
export default Dashboard;
